var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentsConnector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 63,
    viewBox: "0 0 184 63",
    fill: "none",
    stroke: "#888888",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.5 0V8.75C182.5 10.9591 180.709 12.75 178.5 12.75H158.5C156.291 12.75 154.5 14.5409 154.5 16.75V41.5C154.5 43.7091 152.709 45.5 150.5 45.5H5.5C3.29086 45.5 1.5 47.2909 1.5 49.5V62.5",
    strokeWidth: 2,
    strokeDasharray: "6 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentsConnector);
export default __webpack_public_path__ + "static/media/agents-connector.409f56b4a879358cb0d2c27794d576f8.svg";
export { ForwardRef as ReactComponent };